import React from 'react';

/**
 * Isotipo de Cuadrilla Maestra. Usa el asset oficial en public/logo.png.
 * `tone` se conserva por compatibilidad; el PNG ya trae la versión correcta.
 */
const LogoMark = ({ size = 36, className = '' }) => (
  <img
    src={`${process.env.PUBLIC_URL}/logo.png`}
    alt="Cuadrilla Maestra"
    className={className}
    style={{ height: size, width: 'auto', display: 'block' }}
  />
);

export default LogoMark;
